import { DatatableComponent } from "../../../../helpers/DatatableComponent";
import { formatPhone } from "../../../../helpers/FormatInputs";
import { KTSVG } from "../../../../helpers/KTSVG";
import { defaultProfileImage } from "../../../../utils/constants";
import { capitalLetter } from "../../../../utils/inputValidations";

type Props = {
    partner: any;
}

export const GeneralProfileExpertTab = ({ partner }: Props) => {
    return (
        <>
            {/* detail company */}
            <div className={`admin-experience-details-card d-flex flex-row w-100 justify-content-between`}>
                <div className="admin-experience-details-user">
                    <div className="admin-experience-details-id d-flex flex-row">
                        <div className="w-50"># {partner?.id}</div>
                        {/* <div className="w-50 text-end">{EXPERIENCE_STATUS_LIST.map((item)=>item.id == partner.status ? (item.name) : null)}</div> */}
                    </div>

                    <div className="admin-experience-details-user-info">
                        <img className="admin-experience-details-avatar" src={partner?.logo || defaultProfileImage} onError={(e) => {e.currentTarget.src = defaultProfileImage;}} />
                        <div className="d-flex flex-column">
                            <span className="admin-experience-details-value fw-bold">
                                {partner?.companyName}
                            </span>
                            <span className="admin-experience-details-value">
                                {partner?.address ?? 'N/A'}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="admin-expert-status">
                    <span>
                        {capitalLetter(partner.status)}
                    </span>
                </div>
            </div>

            {/* Section contact */}
            <div className={`admin-experience-details-summary`}>
                <div className="admin-experience-details-summary-header">
                    <h4 className="admin-experience-details-summary-title">
                        EMPLOYEES DETAILS
                    </h4>
                </div>

                <DatatableComponent
                    columns={[
                        {
                            key: 'name',
                            label: 'Name'
                        },
                        {
                            key: 'email',
                            label: 'Email'
                        },
                        {
                            key: 'phone',
                            label: 'Phone',
                            getValue: (row) => <>{formatPhone(row?.contactPhone ?? '')}</> 
                        },
                        {
                            key: '',
                            label: '',
                            getValue: (row) => <span className="primary">{row.isPrimary ? 'PRIMARY': ''}</span>
                        },
                        {
                            key: 'status',
                            label: 'Status',
                            getValue: (row) => <>{capitalLetter(row.status)}</> 
                        }
                    ]}
                    cursorPointer={false}
                    data={partner.employees}  
                    textNoWrap
                    tableClassName="admin-expert-employees-table"
                />
            </div>
            
            {/* Section payment */}
            <div className={`admin-experience-details-summary `}>
                <div className="admin-experience-details-summary-header">
                    <h4 className="admin-experience-details-summary-title">
                        PAYMENT METHOD
                    </h4>
                </div>

                {partner?.bankAccount?.length > 0 ? (
                    partner?.bankAccount.map((bankaccount:any)=>(<div className="tap-add-experience-2-category-pill tap-add-experience-2-category-pill--selected align-items-start">
                            <div className="d-flex flex-row mt-2">
                                <div className="admin-experience-details-summary p-3 pt-0 pb-2">
                                    <KTSVG path="/media/svg/nobilis/bank.svg" />
                                </div>
                            </div>
                        <div className="admin-experience-details-field w-100">
                            <span className="admin-experience-details-value fw-normal">{bankaccount?.bankName}</span>
                            <span className="admin-experience-details-value">
                                {bankaccount?.beneficiary}
                            </span>
                            <span className="partners-detail-bank-account-info">Bank Account: {bankaccount?.iban}</span>
                            <div className="d-flex justify-content-between align-items-center">
                                <span className="partners-detail-bank-account-swift-code">SWIFT CODE: {bankaccount?.swiftCode}</span>
                                <span className="partners-detail-bank-account-primary">{bankaccount?.isPrimary ? 'Primary' : ''}</span>
                            </div>
                        </div>
                    </div>))
                    ) : null
                }
            </div>
        </>
    )
}